"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartConfigurationExtender_1 = require("./CartConfigurationExtender");
exports.default = CartConfigurationExtender_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartConfigurationContainer/CartConfigurationExtender/index.js
// module id = 2352
// module chunks = 8